import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { type InferType } from 'yup'
import * as yup from 'yup'

import Input from '@/compoments/common/Input'
import { useUpdateMeMutation } from '@/services/auth'
import ChecBox from '@/compoments/common/ChecBox'
import { useSelector } from 'react-redux'

const schema = yup.object().shape({
    oldPassword: yup.string().when(['password', 'confirmPassword'], {
        is: (password: any, confirmPassword: any) =>
            password.length > 0 || confirmPassword.length > 0,
        then: schema => schema.required('Old password is required'),
        otherwise: schema => schema.notRequired(),
    }),
    // oldPassword: yup.string().optional().test(
    //     'isValidPassword',
    //     'Old password is required',
    //     function (value) {
    //         const { password,  confirmPassword} = this.parent;
    //         return !password || (password && confirmPassword) ;
    //     }
    // ).nullable(),
    password: yup.string().nullable(),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password')], 'Passwords must match')
        .optional(),
    // password: yup.string().when(['oldPassword', 'confirmPassword'], {
    //     is: (oldPassword: any, confirmPassword: any) => oldPassword.length > 0 || confirmPassword.length > 0,
    //     then: (schema) => schema.required('Old password is required'),
    //     otherwise: (schema) => schema.notRequired(),
    // }),
    // confirmPassword: yup
    //     .string()
    //     .when(['oldPassword', 'password'], {
    //         is: (oldPassword: unknown, password: unknown) => !!oldPassword || !!password,
    //         then: (schema) =>
    //             schema.oneOf([yup.ref('password')], 'Passwords must match')
    //             .required('Confirm password is required'),
    //         otherwise: (schema) => schema.notRequired(),
    //     }
    // ),
    twoFactorAuthentication: yup
        .string()
        .oneOf(['opt_email', 'otp_sms', 'authenticator'])
        .required('2FA is required'),
})

type FormType = InferType<typeof schema>

export const SecuritySettings = () => {
    const { user, activeRole } = useSelector((state: any) => state.auth)
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<FormType>({
        mode: 'onChange',
        // defaultValues: {
        //     twoFactorAuthentication: user?.twoFactorAuthentication || '',
        // },
        resolver: yupResolver(schema),
    })

    const [updateMe] = useUpdateMeMutation()
    useEffect(() => {
        if (!user) return
        setValue('twoFactorAuthentication', user?.twoFactorAuthentication || '')
    }, [user])
    const onSubmit = async (data: FormType) => {
        const formData = new FormData()
        if (data.password && data.oldPassword) {
            formData.append('password', data.password)
            formData.append('oldPassword', data.oldPassword)
        }
        if (data.twoFactorAuthentication) {
            formData.append(
                'twoFactorAuthentication',
                data.twoFactorAuthentication,
            )
        }
        try {
            const res = await updateMe(formData)

            console.log(res, 'res')

            if (res?.data?.success) {
                toast.success('Updated successfully!')
            } else {
                toast.error(res?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            toast.error('Something went wrong')
            console.error('rejected', error)
        }
    }

    return (
        <div className="settings-body">
            <div className="settings__header ">
                <h4 className="mb-22">Security</h4>
                <button
                    type="submit"
                    onClick={handleSubmit(onSubmit)}
                    className="btn btn--primary-gradient btn--lg fullRadius mb-22"
                >
                    <span className="text--md">Save Changes</span>
                </button>
            </div>

            <div className="row gy-42">
                <div className="col-lg-5">
                    <h5 className="mb-13">General Info</h5>
                    <p className="text--xs color-text-color-1">
                        Edit information about your personal data
                    </p>
                </div>
                <div className="col-lg-7">
                    <div className="form-group--row input--lg mb-22">
                        <Input
                            togglePasswordShow
                            label="Password"
                            className="input input--outline  w-full"
                            type="password"
                            placeholder=""
                            error={errors.oldPassword?.message}
                            {...register('oldPassword')}
                        />
                    </div>
                    <div className="form-group--row input--lg mb-22">
                        <Input
                            togglePasswordShow
                            label="New Password"
                            className="input input--outline  w-full"
                            type="password"
                            placeholder=""
                            error={errors.password?.message}
                            {...register('password')}
                        />
                    </div>
                    <div className="form-group--row input--lg">
                        <Input
                            togglePasswordShow
                            label="Confirm Password"
                            className="input input--outline  w-full"
                            type="password"
                            placeholder=""
                            error={errors.confirmPassword?.message}
                            {...register('confirmPassword')}
                        />
                    </div>
                </div>
                {/* <div className="col-lg-5">
                    <h5 className="mb-13">Two-Factor Authentication</h5>
                </div>
                <div className="col-lg-7">
                    <div className="form-group--row input--lg mb-22">
                        <ChecBox 
                            type='radio'
                            label="Use Email"
                            value={'opt_email'}
                            text='Send code to your email' 
                            {...register('twoFactorAuthentication')}
                        />
                    </div>
                    <div className="form-group--row input--lg mb-22">
                        <ChecBox 
                            type='radio'
                            label="Use OTP"
                            value={'otp_sms'}
                            text='Authenticate by SMS on your phone number' 
                            {...register('twoFactorAuthentication')}
                            
                        />
                    </div>
                    <div className="form-group--row input--lg mb-22">
                        <ChecBox 
                            type='radio'
                            label="Use Authenticator"
                            value={'authenticator'}
                            text='Connect to Authenticator App'
                            {...register('twoFactorAuthentication')}
                            
                        />
                    </div>
                </div> */}
            </div>
        </div>
    )
}
